export const ckeconfig = {
    height: 300,
    //filebrowserBrowseUrl: '/#/media/images/',
    filebrowserImageBrowseUrl: "/#/media/images/",
    //filebrowserUploadUrl: '/uploader/upload.php'
    toolbar: [
            ["Bold", "Italic", "Underline", "-", "RemoveFormat"],
            [
                "NumberedList",
                "BulletedList",
                //"-",
                //"Outdent",
                //"Indent",
                "-"
                //"Blockquote"
            ],
            ["Cut", "Copy", "Paste"],
            ["Link", "Unlink"],
            ["Maximize"]
            //["Image", "Format"]
            //['TextColor', 'BGColor'],
            //['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
        ]
        //extraPlugins: 'justify,colorbutton,imageuploader,floatpanel,panelbutton,button,panel'
};


// WEBPACK FOOTER //
// ./src/core/config/ckeditor.js